var exports = {
  "k": "xfb577c5e--390e54--container",
};

module.exports = exports;
